var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup852(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.529,
    height: 12.53,
    viewBox: "0 0 12.529 12.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-836.976 -656.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.956,139.693a2.916,2.916,0,0,0-2.547-2.54,3.055,3.055,0,0,0-.346-.02,2.909,2.909,0,0,0-2.045,4.973,2.291,2.291,0,0,1,.706,1.627v.336h2.685v-.338a2.24,2.24,0,0,1,.681-1.6,2.9,2.9,0,0,0,.865-2.437h0Z",
    transform: "translate(703.173 522.793)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.772,494.161a.672.672,0,0,0,.633-.447h-1.266A.672.672,0,0,0,230.772,494.161Z",
    transform: "translate(612.469 174.938)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.286,439.528a.224.224,0,0,0,.224.224h1.79a.224.224,0,0,0,.224-.224v-.671h-2.237Z",
    transform: "translate(631.836 228.453)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.161,2.014a.447.447,0,0,0,.447-.447V.447a.447.447,0,0,0-.895,0V1.566A.448.448,0,0,0,238.161,2.014Z",
    transform: "translate(605.079 656.57)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.922,65.555a.458.458,0,0,0,.633,0,.447.447,0,0,0,0-.633l-.791-.791a.447.447,0,1,0-.633.633Z",
    transform: "translate(774.542 594.137)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.014,238.161a.448.448,0,0,0-.447-.447H.447a.447.447,0,0,0,0,.895H1.566A.447.447,0,0,0,2.014,238.161Z",
    transform: "translate(836.976 424.674)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.356,379.094a.448.448,0,0,0-.433.117l-.791.791a.447.447,0,0,0,0,.633.458.458,0,0,0,.633,0l.791-.791a.448.448,0,0,0-.2-.749Z",
    transform: "translate(774.541 286.769)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.843,379.21a.448.448,0,1,0-.633.633l.791.791a.458.458,0,0,0,.633,0,.448.448,0,0,0,0-.633Z",
    transform: "translate(467.174 286.769)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.28,237.714h-1.119a.447.447,0,1,0,0,.895h1.119a.447.447,0,1,0,0-.895Z",
    transform: "translate(417.778 424.674)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.865,65.555l.791-.791a.447.447,0,0,0-.633-.633l-.791.791a.447.447,0,0,0,0,.633A.458.458,0,0,0,379.865,65.555Z",
    transform: "translate(467.152 594.136)",
    fill: "#ffc107"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup852);
export default __webpack_public_path__ + "static/media/Group 852.bb5c5f0e351e4a905bfabc39b2a0a6ca.svg";
export { ForwardRef as ReactComponent };